(function () {
  'use strict';

  let activeTab = null;

  function initializeOrRestoreTabs() {
    const contentTabs = document.querySelectorAll('.match-info-tabs__content > div.match-info-tabs__content-tab');
    const tabButtons = document.querySelectorAll('.match-info-tabs__tab-button');

    // Hide all content tabs
    contentTabs.forEach((tab) => (tab.style.display = 'none'));

    // Remove active class from all buttons
    tabButtons.forEach((btn) => btn.classList.remove('match-info-tabs__tab-button--active'));

    // Try to restore the previously active tab, otherwise use first tab
    let targetButton = null;

    if (activeTab) {
      targetButton = document.querySelector(`.match-info-tabs__tab-button[data-tab="${activeTab}"]`);
    }

    // If no active tab or target button doesn't exist, use first tab
    if (!targetButton) {
      targetButton = document.querySelector('.match-info-tabs__tab-button');
      if (targetButton) {
        activeTab = targetButton.getAttribute('data-tab');
      }
    }

    if (targetButton) {
      targetButton.classList.add('match-info-tabs__tab-button--active');
      const activeContent = document.getElementById(`${activeTab}-tab`);
      if (activeContent) {
        activeContent.style.display = 'block';
      }
    }
  }

  function init() {
    // Initial setup
    initializeOrRestoreTabs();

    // Handle tab clicks using event delegation
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.match-info-tabs__tab-button');
      if (button) {
        e.preventDefault();
        activeTab = button.getAttribute('data-tab');

        // Remove active class from all buttons
        document.querySelectorAll('.match-info-tabs__tab-button').forEach((btn) => {
          btn.classList.remove('match-info-tabs__tab-button--active');
        });
        button.classList.add('match-info-tabs__tab-button--active');

        // Hide all content tabs and show the active one
        const contentTabs = document.querySelectorAll('.match-info-tabs__content > div.match-info-tabs__content-tab');
        contentTabs.forEach((tab) => (tab.style.display = 'none'));

        const activeContent = document.getElementById(`${activeTab}-tab`);
        if (activeContent) {
          activeContent.style.display = 'block';
        }
      }
    });

    // Listen for custom event when live game content is refreshed by AJAX
    document.addEventListener('live-game-refreshed', function () {
      // Small delay to ensure DOM is updated
      setTimeout(initializeOrRestoreTabs, 50);
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  $(document).on('live-game-refreshed', () => {
    setTimeout(initializeOrRestoreTabs, 50);
  });
})();
